/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_AllInputs */

const cs_portals_verify_all = /** @type {(inputs: Portals_Verify_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřit všechny portály`)
};

const en_portals_verify_all = /** @type {(inputs: Portals_Verify_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify all portals`)
};

/**
* | output |
* | --- |
* | "Verify all portals" |
*
* @param {Portals_Verify_AllInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_all = /** @type {((inputs?: Portals_Verify_AllInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_AllInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_all(inputs)
	return cs_portals_verify_all(inputs)
});